import { getApp, initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import {
  getAuth,
  initializeAuth,
  browserLocalPersistence,
  indexedDBLocalPersistence,
} from "firebase/auth";
import { getFunctions } from "firebase/functions";

/** Must match the region where Cloud Functions are deployed (`firebase deploy`). */
const FUNCTIONS_REGION = "us-central1";

/**
 * HTTP function URL (Gen2). Uses fetch + Bearer ID token — avoids callable+CORS issues.
 * Deploy: exports.deleteUserAuthHttp in functions/index.js
 */
export const DELETE_USER_AUTH_HTTP_URL =
  "https://us-central1-kesher9263-1.cloudfunctions.net/deleteUserAuthHttp";

/** Gen2 HTTP — increments appConfig/tsavSmsLimit (Bearer ID token, admin/parentsUser). */
export const INCREMENT_TSAV_SMS_LIMIT_HTTP_URL =
  "https://us-central1-kesher9263-1.cloudfunctions.net/incrementTsavSmsLimitHttp";

const firebaseConfig = {
  apiKey: "AIzaSyAmGIqxE5CvybpTp8--xMgHboGaiKq6er8",
  authDomain: "kesher9263-1.firebaseapp.com",
  projectId: "kesher9263-1",
  storageBucket: "kesher9263-1.firebasestorage.app",
  messagingSenderId: "863030718621",
  appId: "1:863030718621:web:e86bb7921f796d80096474",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

/** Prefer IndexedDB then localStorage so sessions survive aggressive mobile “cache” clears when possible. */
function createMainAuth() {
  try {
    return initializeAuth(app, {
      persistence: [indexedDBLocalPersistence, browserLocalPersistence],
    });
  } catch (e) {
    if (e?.code === "auth/already-initialized") {
      return getAuth(app);
    }
    throw e;
  }
}
export const auth = createMainAuth();
export const functions = getFunctions(app, FUNCTIONS_REGION);

/**
 * Deletes the Firebase Auth user via Cloud Function (HTTP). Requires signed-in admin.
 */
export async function callDeleteUserAuthHttp({ uid, email }) {
  const user = auth.currentUser;
  if (!user) {
    throw new Error("unauthenticated");
  }
  const idToken = await user.getIdToken();
  const res = await fetch(DELETE_USER_AUTH_HTTP_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify({ uid, email }),
  });
  let data = {};
  try {
    data = await res.json();
  } catch {
    /* ignore */
  }
  if (!res.ok) {
    const err = new Error(data.message || data.error || res.statusText);
    err.code = data.error;
    throw err;
  }
  return data;
}

/** Separate Auth instance so createUserWithEmailAndPassword does not replace the admin session. */
const SECONDARY_NAME = "Secondary";
const secondaryApp = (() => {
  try {
    return getApp(SECONDARY_NAME);
  } catch {
    return initializeApp(firebaseConfig, SECONDARY_NAME);
  }
})();
export const secondaryAuth = getAuth(secondaryApp);

export default app;
